// pages/Login.jsx
import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../assets/css/Login.css';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setError('');
      setLoading(true);
      const result = await login(email, password);
      
      if (result.success) {
        toast.success('Successful login!', {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        setTimeout(() => {
          navigate('/admin');
        }, 1000);

      } else {
        setError(result.message);
        toast.error(result.message || 'Failed to log in');
      }
    } catch {
      setError('Failed to log in');
      toast.error('Failed to log in');
    }
    
    setLoading(false);
  };

  return (
    <>
      <Container fluid className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
        <Row className="w-100 justify-content-center">
          <Col md={4} sm={8} xs={12}>
            <Card className="shadow">
              <Card.Body className="p-5">
                <h2 className="text-center mb-4">Administrator-Anmeldung</h2>
                <p className="text-center">Melden Sie sich an, um Ihre Sitzung zu starten</p>

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </Form.Group>
                  <Button
                    disabled={loading}
                    className="w-100 login-btn"
                    variant="primary"
                    type="submit"
                  >
                    {loading ? 'Log In...' : 'Log In'}
                  </Button>
                  {/* btn to forgot password form */}
                  <div className="text-start mt-3">
                    <button
                      type="button"
                      className="btn btn-link p-0"
                      onClick={() => navigate('/admin/forgot-password')}
                    >
                      Passwort vergessen?
                    </button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}